var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.26774L9.2428 14.6064C4.738 18.8322 -2.0192 12.4935 2.4856 8.26774L9.2428 1.92906C12.246 -0.88813 16.7508 3.33765 13.7476 6.15484L6.9904 12.4935C5.4888 13.9021 3.2364 11.7892 4.738 10.3806L11.4952 4.04195",
    stroke: "#A6A6A6",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttech);
export default __webpack_public_path__ + "static/media/attech.30c952f1a10b9395d19ceb36d76e8954.svg";
export { ForwardRef as ReactComponent };